import React, { Component } from 'react';
import { getTrustReport, getTrustReportDates } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import SearchFilter from './SearchFilter';
import Loading from '../Loading';

class TrustReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchIndex: {
                cltClientId: "",
                date: "",
                pdf: false
            },
            disabled: true,
            reportDates: [],
            loading: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "reports_trust.md");
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e, data) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                [data.name]: data.value
            }
        }, () => {
            if (data.name === "cltClientId") {
                this.setState({
                    loading: true
                }, () => {
                    getTrustReportDates(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                        if (response != null && (response instanceof Array)) {
                            this.setState({
                                reportDates: response.map((item, index) => {
                                    return {
                                        value: item,
                                        id: index,
                                        key: index,
                                        text: item
                                    }
                                }),
                                searchIndex: {
                                    ...this.state.searchIndex,
                                    date: ""
                                },
                                disabled: false,
                                loading: false
                            });
                        }
                    }).then(() => {
                        this.setState({
                            loading: false
                        });
                    })


                })
            }
        });
    }

    handleSubmit = (pdf) => {
        this.setState({
            loading: true,
            searchIndex: {
                ...this.state.searchIndex,
                pdf: pdf
            }
        }, () => {
            getTrustReport(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                if (response !== null) {
                    let disposition = response.request.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        let matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            let filename = matches[1].replace(/['"]/g, '');
                            if (typeof window.navigator.msSaveBlob !== 'undefined') {
                                // IE workaround for "HTML7007: One or more blob URLs were 
                                // revoked by closing the blob for which they were created. 
                                // These URLs will no longer resolve as the data backing 
                                // the URL has been freed."
                                window.navigator.msSaveBlob(new Blob([response.data]), filename);
                            } else {
                                const url = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = url;
                                link.setAttribute('download', filename);
                                document.body.appendChild(link);
                                link.click();
                            }
                        }
                    }
                }
            }).then(() => {
                this.setState({
                    loading: false
                });
            })
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
            this.setState({
                searchIndex: {
                    cltClientId: "",
                    date: "",
                    pdf: null
                },
                disabled: true,
                reportDates: []
            });
        }
    }

    render() {
        if (this.state.loading) {
            return (
                <Loading />
            )
        }
        return (
            <div>
                <BreadcrumbCustom {...this.props} parent="Reports" child={[{ name: "Trust", url: null }]} />
                <SearchFilter {...this.props} reportTitle="Trust Report" loading={this.state.loading} disabled={this.state.disabled} reportDates={this.state.reportDates} cltClientId={this.state.searchIndex.cltClientId} handleChange={this.handleChange} handleSubmit={this.handleSubmit} date={this.state.searchIndex.date} />
            </div>
        );
    }
}
export default TrustReport;


// WEBPACK FOOTER //
// ./src/app/ui/reports/TrustReport.js